import React from 'react'
import { bool, arrayOf, string, object } from 'prop-types'
import intl from 'react-intl-universal'

import Typography from 'components/atoms/Typography'
import BaseSocmedIcon from 'components/atoms/BaseSocmedIcon'
import ScholarshipRegistrationButton from 'components/molecules/ScholarshipRegistrationButton'
import ScholarshipDownloadBrochure from 'components/molecules/ScholarshipDownloadBrochure'

import ScholarshipSvg from 'components/atoms/SVGIcons/Scholarship'
import TimeSvg from 'components/atoms/SVGIcons/Time'
import SchoolSvg from 'components/atoms/SVGIcons/School'

const ScholarshipBriefDetail = ({
  providers,
  purposes,
  shortInfo,
}) => {
  const providersText = providers && providers.length > 0 ?
    `Beasiswa ${providers.map(provider => intl.get(`search.provider.${provider}`)).join(' · ')}` :
    ''
  const purposesText = purposes && purposes.length > 0 ?
    `Kampus ${purposes.map(purpose => intl.get(`search.purpose.${purpose}`)).join(' & ')}` :
    ''

  return (
    <>
      {
        providersText &&
        <div className="scholarship-brief-detail__item">
          <ScholarshipSvg fill="#fff" />
          <Typography variant="subbody">{providersText}</Typography>
        </div>
      }
      {
        shortInfo &&
        <div className="scholarship-brief-detail__item">
          <TimeSvg fill="#fff" />
          <Typography variant="subbody">{shortInfo}</Typography>
        </div>
      }
      {
        purposesText &&
        <div className="scholarship-brief-detail__item">
          <SchoolSvg fill="#fff" />
          <Typography variant="subbody">{purposesText}</Typography>
        </div>
      }
      <style jsx>
        {`
          .scholarship-brief-detail__item {
            width: 100%;
            display: flex;
            align-items: center;
            margin: 16px 0px 0px;
            :global(.text-variant-subbody) {
              color: #fff !important;
            }
            :global(svg) {
              margin-right: 8px;
              fill: #fff;
              width: 16px;
              height: 16px;
            }
          }
        `}
      </style>
    </>
  )
}

ScholarshipBriefDetail.propTypes = {
  providers: arrayOf(string),
  purposes: arrayOf(string),
  shortInfo: string,
}

const ScholarshipPageBannerContent = ({
  registrationUrl,
  brochure,
  socialMedia,
  shortInfo,
  providers,
  purposes,
  paid,
  hasTriggered,
  setHasTriggered,
}) => (
  <>
    <div className="scholarship-page-banner__detail">
      <ScholarshipBriefDetail
        purposes={purposes}
        providers={providers}
        shortInfo={shortInfo}
      />
    </div>
    {
      socialMedia &&
      <div className="scholarship-page-banner__socmeds">
        {
          Object.keys(socialMedia).map((type, idx) => (
            socialMedia[type] &&
            <BaseSocmedIcon
              url={socialMedia[type]}
              type={type}
              key={`scm-icon-${idx}`}
              backgroundColor="#0fc3c4"
            />
          ))
        }
      </div>
    }
    <div className="scholarship-page-banner__actions">
      {
        paid && registrationUrl &&
        <ScholarshipRegistrationButton hasTriggered={hasTriggered} setHasTriggered={setHasTriggered} />
      }
      {
        brochure &&
        <ScholarshipDownloadBrochure />
      }
    </div>
    <style jsx>
      {`
        .scholarship-page-banner{
          &__actions {
            margin: 16px -8px;
          }
          :global(&__button) {
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 2px 4px 0 rgba(107, 143, 188, 0.85);
            padding: 14px 28px;
            border: none;
            margin: 8px;
            width: 100%;
            @media screen and (min-width: 768px) {
              width: unset;
            }
          }
          &__socmeds {
            margin: 16px -4px;
          }
        }
      `}
    </style>
  </>
)

ScholarshipPageBannerContent.propTypes = {
  registrationUrl: string,
  brochure: string,
  socialMedia: object,
  providers: arrayOf(string),
  purposes: arrayOf(string),
  shortInfo: string,
  paid: bool,
}

export default ScholarshipPageBannerContent
